import { AdminRepository } from "../../../../data/repository/admin/AdminRepository";
import { Admin } from "../../../model/Admin";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetAdminInfoUseCase {
  invoke: () => Promise<ResponseState<Admin>>;
}

export class GetAdminInfoUseCaseImpl implements GetAdminInfoUseCase {
  private repo: AdminRepository;

  constructor(repo: AdminRepository) {
    this.repo = repo;
  }

  async invoke(): Promise<ResponseState<Admin>> {
    try {
      let response = await this.repo.getAdminInfo();
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
